// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__7U7bG","actionsCol":"EnrolledClinics_actionsCol__25IXC"};